module.exports = __webpack_public_path__ + "assets/img/Document.9c15c77a.svg";